StoreFront = {
    getGroupedProductsForProductDetailsPage: async function (queryString) {
        const PAGE_SIZE = 250;
        const allEdges = [];
        let after = null;

        const search = `${queryString} AND available_for_sale:true AND published_status:published`;
        const FIELDS = `
            title
            handle
            onlineStoreUrl
            ndFootwearGender: metafield(namespace: "custom", key: "nd_footwear_gender") { namespace key value }
            ndProductType: metafield(namespace: "custom", key: "nd_product_type") { namespace key value }
            ndFootwearColour: metafield(namespace: "custom", key: "nd_footwear_colour") { namespace key value }
            ndFootwearColour2: metafield(namespace: "custom", key: "nd_footwear_colour_2") { namespace key value }
            ndFootwearSoleColour: metafield(namespace: "custom", key: "nd_footwear_sole_colour") { namespace key value }
            ndFootwearSoleMaterial: metafield(namespace: "custom", key: "nd_footwear_sole_material") { namespace key value }
            ndFootwearMaterialGroup: metafield(namespace: "custom", key: "nd_footwear_material_group") { namespace key value }
        `;

        while (true) {
            const afterArg = after ? `, after: "${after}"` : '';
            const gql = `{
              products(first: ${PAGE_SIZE}${afterArg}, query: "${search}") {
                edges {
                  cursor
                  node { ${FIELDS} }
                }
                pageInfo { hasNextPage endCursor }
              }
            }`;

            const res = await this.request(gql);
            const { edges = [], pageInfo = {} } = res?.data?.products || {};

            if (!edges.length) break;

            allEdges.push(...edges);

            if (!pageInfo.hasNextPage) break;

            after = pageInfo.endCursor;
        }

        return { data: { products: { edges: allEdges } } };
    },

    request: async function(query) {
        return fetch('/api/2024-01/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': "543d81d1dcd82292ea56f451fee09155"
            },
            body: JSON.stringify({query})
        })
            .then((response) => response.json())
            .then((response) => {return response;});
    }
}